var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4786 5.16462C15.5674 4.2534 14.09 4.2534 13.1788 5.16462L6.34345 12C4.78135 13.5621 4.78135 16.0947 6.34345 17.6568C7.90554 19.2189 10.4382 19.2189 12.0003 17.6568L19.1207 10.5364C19.5112 10.1459 20.1444 10.1459 20.5349 10.5364C20.9254 10.927 20.9254 11.5601 20.5349 11.9507L13.4145 19.0711C11.0714 21.4142 7.27238 21.4142 4.92923 19.0711C2.58609 16.7279 2.58609 12.9289 4.92923 10.5858L11.7646 3.75041C13.4569 2.05813 16.2006 2.05813 17.8929 3.75041C19.5851 5.44268 19.5851 8.18639 17.8929 9.87866L11.0685 16.7031C10.0271 17.7445 8.33862 17.7445 7.29722 16.7031C6.25582 15.6617 6.25582 13.9732 7.29722 12.9318L13.5187 6.71039C13.9092 6.31986 14.5424 6.31986 14.9329 6.71039C15.3234 7.10091 15.3234 7.73408 14.9329 8.1246L8.71143 14.346C8.45108 14.6064 8.45108 15.0285 8.71143 15.2889C8.97178 15.5492 9.39389 15.5492 9.65424 15.2889L16.4786 8.46445C17.3899 7.55323 17.3899 6.07584 16.4786 5.16462Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.9d8f4abbe0600a6fe42477226effdb41.svg";
export { ForwardRef as ReactComponent };